<template>
  <bj-modal
    v-model="unmatchAnAgent.visible"
    size="auto"
    title="Unmatch Agent"
  >
    <div
      slot="content"
      class="unmatch-agent-modal"
    >
      <div
        v-if="!prevAgentName"
        class="text-center"
      >
        <q-spinner-puff
          color="primary"
          size="60px"
        />
      </div>
      <div
        v-else
        class="row gutter-sm"
      >
        <div
          v-if="isTimeLeft"
          class="col-auto"
        >
          {{ prevAgentName }} will be unmatched from this tour, and we'll be
          back to searching for other agents.<br>
          There are {{ minutesUntilCutoff }} minutes left until the timeout to find an agent.
        </div>
        <div
          v-else
          class="col-auto"
        >
          As there's no time to look for a new agent, {{ prevAgentName }} will be
          unmatched from this tour, and this tour will be cancelled.<br>
          The lead will be notified and prompted to schedule a different time.
        </div>
        <div
          class="text-right col-12"
          center
        >
          <span class="button">
            <q-btn
              padding
              outline
              label="cancel"
              @click="closeModal"
            />
          </span>
          <span v-if="isTimeLeft">
            <q-btn
              padding
              outline
              label="Unmatch agent"
              @click="submitUnmatchAnAgent"
            />
          </span>
          <span v-else>
            <q-btn
              padding
              outline
              label="Unmatch agent and cancel tour"
              @click="submitUnmatchAnAgent"
            />
          </span>
        </div>
      </div>
    </div>
  </bj-modal>
</template>

<script>
export default {
  name: 'BjUnmatchAgentModal',
  components: {},
  props: {
    unmatchAnAgent: {
      type: Object,
      required: true,
    },
  },
  data() {
    const { inquiry } = this.unmatchAnAgent.payload;
    const { schedule } = inquiry.schedule_inquiry;

    const type = schedule.type.replace('-', '_');
    const cutoff = this.getSetting(`auto_delete_inquiry_schedule_time_${type}`, inquiry.property.market_id);

    const minutesUntilTour = this.moment(schedule.tour.tour_at).diff(this.moment(), 'minutes');
    const isTimeLeft = minutesUntilTour > cutoff;
    const minutesUntilCutoff = minutesUntilTour - cutoff;
    return {
      prevAgentName: schedule.tour.user.full_name,
      isTimeLeft,
      minutesUntilCutoff,
    };
  },
  methods: {
    closeModal() {
      this.$root.$emit('close-unmatch-agent-modal');
    },
    submitUnmatchAnAgent() {
      this.uiConfirm(`Are you sure you want to unmatch this inquiry from ${this.prevAgentName}?`).then(() => {
        this.unmatchAnAgent.loading = true;
        this.api().request('POST', `schedules/${this.unmatchAnAgent.payload.inquiry.schedule_inquiry.schedule_id}/unmatch`).then(() => {
          this.unmatchAnAgent.loading = false;
          this.uiNotify('Inquiry has unmatched successfully from agent');
          this.$root.$emit('close-unmatch-agent-modal', true);
        }).catch((error) => {
          this.unmatchAnAgent.loading = false;
          this.uiNotify(this.getFirstError(error) || error.message || 'Error occurred', 'negative');
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
    .unmatch-agent-modal {
        max-width: 35vw;
    }
    .button {
        padding: 10px;
    }
</style>
